<div class="wireframe-report">
	@if (loadingWireframe()) {
		<nz-spin nzSimple nzSize="large"></nz-spin>
	}

	@if (!loadingWireframe() && report()) {
		<div class="report-top-row">
			<div class="report-header">
				<div class="title">{{ report()!.wireframe_data.player_title }}</div>
				<div class="task-instructions">{{ report()!.wireframe_data.player_instructions }}</div>
			</div>

			<div class="score-summary">
				<div class="section-label">Score Summary</div>
				<div class="summary-grid">
					<div class="summary-card first-attempt">
						<div class="summary-title">First Attempt</div>
						<div class="summary-value">{{ report()!.student_results.summary.firstAttempt.count }}</div>
						<div class="summary-points">
							{{ report()!.student_results.summary.firstAttempt.points }} point each
						</div>
					</div>

					<div class="summary-card second-attempt">
						<div class="summary-title">Second Attempt</div>
						<div class="summary-value">{{ report()!.student_results.summary.secondAttempt.count }}</div>
						<div class="summary-points">
							{{ report()!.student_results.summary.secondAttempt.points }} point each
						</div>
					</div>

					<div class="summary-card incorrect">
						<div class="summary-title">Incorrect</div>
						<div class="summary-value">{{ report()!.student_results.summary.incorrect.count }}</div>
						<div class="summary-points">
							{{ report()!.student_results.summary.incorrect.points }} points
						</div>
					</div>
				</div>

				<div class="final-score">Total Score: {{ report()!.student_results.score }}</div>
			</div>
		</div>

		<div class="section-label">Assessment Objective</div>
		<div class="objective">{{ report()!.wireframe_data.assessment_objective }}</div>

		<div class="section-label">Questions</div>
		<div class="questions">
			@for (question of questions(); track question; let index = $index) {
				<div class="question-card" [class.incorrect]="isQuestionIncorrect(question)">
					<div class="question-header">
						<div class="question-number">{{ index + 1 }}.</div>
						<div class="question-text">{{ question.text }}</div>
						<div
							class="status"
							[class.correct]="!isQuestionIncorrect(question)"
							[class.incorrect]="isQuestionIncorrect(question)"
						>
							{{ getQuestionStatus(question) }}
						</div>
					</div>

					<div class="lang-function">{{ question.lang_function }}</div>
					<div class="assessment-objective">{{ question.assessment_objective }}</div>

					@if (isSequenceQuestion(question)) {
						<div class="response-block sequence-block">
							<div class="label">Student Response Sequence</div>
							<div class="sequence-items">
								@for (
									item of parseSequence(question.student_answer);
									track $index;
									let order = $index
								) {
									<div
										class="sequence-item"
										[class.correct]="isSequenceItemCorrect(question, order)"
										[class.incorrect]="!isSequenceItemCorrect(question, order)"
										nz-tooltip
										[nz-tooltip]="getSequenceItemTooltip(question, order)"
										nzTooltipPlacement="top"
									>
										<span class="order">{{ order + 1 }}</span>
										<span class="value">{{ item }}</span>
									</div>
								}
							</div>
						</div>
					} @else {
						<div class="response-block">
							<div class="label">Student Response</div>
							<div class="text">{{ question.student_answer }}</div>
						</div>

						@if (question.correct !== true) {
							<div class="response-block">
								<div class="label">Correct Answer</div>
								<div class="text">{{ question.correct_answer }}</div>
							</div>
						}
					}

					@if (question.feedback) {
						<div class="question-feedback">{{ question.feedback }}</div>
					}
				</div>
			}
		</div>
	}
</div>
